"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queuesColors = void 0;
//Quantidade de clientes na fila
exports.queuesColors = [
    {
        colorClass: "alert-secondary",
        quantity: -5
    },
    {
        colorClass: "alert-success",
        quantity: 1,
    },
    {
        colorClass: "alert-warning",
        quantity: 5
    },
    {
        colorClass: "alert-danger",
        quantity: 10
    }
];
